<template>
  <div class="aboutContainer">
    <full-page :options="options" ref="fullpage">
      <div class="section pageBox1">
        <!-- 导航 -->
        <div class="navBar">
          <img class="navLogo" src="../assets/logo2.png" alt="" @click="enterHome()" />
          <ul class="navBarItem">
            <!-- <li class="busiz-active-sel">
              <router-link exact to="/" tag="a">首页</router-link>
            </li> -->
            <li>
              <router-link to="/aboutlanshu" exact tag="a">关于兰树</router-link>
            </li>

            <el-dropdown>
              <li>
                <router-link to="/huaiBrand" exact tag="a">兰树品牌</router-link>
              </li>
              <el-dropdown-menu class="elDropdown" slot="dropdown">
                <el-dropdown-item><router-link to="/huaiBrand" tag="a">淮树</router-link></el-dropdown-item>
                <el-dropdown-item><router-link to="/brand" tag="a">心清堂</router-link></el-dropdown-item>
                <el-dropdown-item><router-link to="/shuiBrand" tag="a">水姻缘</router-link></el-dropdown-item>
                <el-dropdown-item><router-link to="/yiBrand" tag="a">一清堂</router-link></el-dropdown-item>
                <el-dropdown-item><router-link to="/zhongBrand" tag="a">Dr.CHUNG<span
                      style="vertical-align: super;">+</span></router-link></el-dropdown-item>
                <el-dropdown-item><router-link to="/lanshuBrand" tag="a">兰树</router-link></el-dropdown-item>
                <el-dropdown-item><router-link to="/zbqfBrand" tag="a">植本清方</router-link></el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <li>
              <router-link to="/park" exact tag="a">智慧园区</router-link>
            </li>
            <li>
              <router-link to="/brandLanshu" exact tag="a">美业菩提</router-link>
            </li>
            <li>
              <router-link to="/school" exact tag="a">兰树商学院</router-link>
            </li>

            <li>
              <router-link to="/dynamicLanshu" exact tag="a">菩提基金会</router-link>
            </li>

            <li>
              <router-link to="/lanshuTrends" exact tag="a">兰树动态</router-link>
            </li>
          </ul>
        </div>

        <!-- <div class="topBgBox">
          <div class="topTitle">兰树</div>
          <div class="topLine"></div>
          <div class="topDetail">
            探索东方广博的历史脉络<br />
            缔造民族护肤品牌新世界<br />
            <span
              style="font-family: SourceHanSansCN-Medium;font-size: 0.93vw;font-weight: medium;"
              >专业、研发、创新、科技</span
            >
            <br />在持续蜕变中探求东方美肌奥秘
          </div>
          <div class="topImg">
            <img src="../assets/newLasur/topName.png" alt="" />
          </div>
        </div> -->

        <div class="pageBoxMiddle">
          <div class="mainContent">
            <div class="aboutUsBox">
              <span>走进兰树</span>
              <div class="introduce">LASUR INTRO</div>
            </div>
            <div class="contentLine"></div>
            <div class="mainContentLeftBox">
              <div class="mainContentLeft">
                兰树化妆品股份有限公司（以下简称公司或兰树）是一家集研发、生产、销售、服务为一体的化妆品公司，旗下拥有“淮树”、“一清堂”、“心清堂”和“水姻缘”四大品牌（以下合称“兰树品牌”）。“兰树品牌”创立至今，一直秉持“取自然之本，集万物精粹”的养肤理念，传承东方养肤智慧，融合现代尖端科学技术，致力于打造更适合东方肌肤的化妆品。
              </div>
              <div class="seeMore" @click="enterAboutUs()">
                <img src="../assets/newLasur/logo.png" alt="" />
                <span>了解更多兰树信息</span>
              </div>
            </div>
            <div class="leftBottom">
              <img src="../assets/newLasur/leftBottom.png" alt="" />
            </div>
            <img class="mainContentRight" src="../assets/newLasur/lefttop.png" alt="" />

          </div>
        </div>


      </div>
      <!-- <div class="section pageBox2">
        <div class="pageBoxOut2">
          <div class="headerTitle1">兰树简介</div>
          <div class="headerLine"></div>
          <div class="headerTitle2">COMPANY INTRODUCTION</div>
          <div class="middleBox">
            <img
              class="bottomImg"
              src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-08-18_14-01-17_78597.png"
              alt=""
            />
            <div class="middleBoxLeft">
              兰树化妆品股份有限公司是一家集研发、生产、销售、服务功能为一体的化妆品公司，旗下拥有“淮树”、“一清堂”、“心清堂”、“Dr.CHUNG<span
                style="vertical-align: super;"
                >+</span
              >”、“水姻缘”五大品牌。公司自2005年创立至今，专注于研究东方肌肤的特质，秉持“取自然之本，集万物精粹”的养肤理念，运用现代生物科技，提取植物成分中的精纯活性能量，打造更适合东方肌肤的护肤品，为东方肌肤提供“正确修护”和“科学护理”的健康美肌护理方案。<br />

            </div>


            <div class="middleBoxLeft middleBoxLeftNew">
              公司在浙江·湖州莫干山国家级高新区，建有高端护肤品智造智能工厂，占地约85
              亩，总建筑面积达10.5万平方米，是集研发中心、工厂生产、现代物流、教育研修于一体的智能化智慧园区。园区建有全智能化的生产车间，引进国际一流的化妆品生产设备，全自动化控制及生产调度系统的应用，对产品质量进行精准控制，同时在减少污染、降低能耗上加大投入，极大的提高了生产能效，推动企业高质量可持续环保发展进程。
              <br />
            </div>

            <div class="middleBoxLeft middleBoxLeftNew">
              目前兰树企业拥有全国省级经销商公司
              115家，线下CS渠道及专业美容院签约合作门店24521家。企业旗下“心清堂”和“Dr.CHUNG<span
                style="vertical-align: super;"
                >+</span
              >”两大品牌领衔，在全国开设品牌专营肌肤管理中心，全国连锁、整店输出，是集AI智能测肤、皮肤顾问面诊、一体化肌肤问题解决方案、专业美容美体护理、休闲社交功能于一体的新风尚肌肤管理中心。
            </div>

          </div>

        </div>
      </div> -->
      <div class="section pageBox3">
        <div class="goTop" @click="scrollToTop"></div>
        <div class="pageBoxOut2">
          <div class="headerTitle1">兰树价值观</div>
          <div class="headerLine"></div>
          <div class="headerTitle2">COMPANY VALUE</div>
          <div class="mainBox">
            <div class="mainBoxItem" v-for="(item, index) in visioningItem" :key="index">
              <img class="mainBoxItemImg" :src="item.img" alt="" />
              <!-- <div class="mainBoxTitleBox">
								<div class="mainBoxTitle1">{{item.title1}}</div>
								<div class="mainBoxTitle2">{{item.title2}}</div>
						   </div> -->
            </div>
          </div>
          <div class="valueBottom">
            <img src="../assets/newLasur/valueBottom.png" alt="" />
          </div>
        </div>
      </div>
      <div class="section pageBox4">
        <div class="goTop" @click="scrollToTop"></div>
        <div class="pageBoxOut2">
          <div class="headerTitle1">企业文化</div>
          <div class="headerLine"></div>
          <div class="headerTitle2">COMPANY CULTURE</div>
          <div class="cultureBox">
            <img src="../assets/newLasur/cultureBg.png" class="bg" alt="" />
            <div class="cultureItem" :class="culture[index]" v-for="(item, index) in cultureItem" :key="index">
              <img class="cultureItemImg" :src="item.img" alt="" />

              <div class="cultureTitle">{{ item.title }}</div>
              <div class="cultureTitle1">{{ item.title1 }}</div>
              <!-- <div class="mainBoxTitleBox">
								<div class="mainBoxTitle1">{{item.title1}}</div>
								<div class="mainBoxTitle2">{{item.title2}}</div>
						   </div> -->
            </div>
          </div>
          <div class="valueBottom">
            <img src="../assets/newLasur/valueBottom.png" alt="" />
          </div>
        </div>
      </div>
      <div class="section pageBox5">
        <div class="goTop" @click="scrollToTop"></div>
        <div class="pageBoxOut2">
          <div class="headerTitle1">企业理念</div>
          <div class="headerLine"></div>
          <div class="headerTitle2">COMPANY IDEA</div>
          <!-- <div class="headerLine"></div> -->
          <div class="ideaBox">
            <!-- <img src="../assets/newLasur/cultureBg.png" class="bg" alt=""> -->
            <div class="ideaBoxLeft">
              <div class="ideaBoxLeftItem ideaItem1">
                <div class="ideaImgBox ideaImgBoxLeft">
                  <img class="ideaImg productImg" src="../assets/aboutLanshu/product.png" alt="" />
                </div>
                <div class="ideaTitleBox">
                  <div class="ideaTitle1">产品理念</div>
                  <div class="ideaTitle3">product concept</div>
                  <div class="ideaTitle2">产品是企业的根与灵魂</div>
                </div>
              </div>

              <div class="ideaBoxLeftItem ideaItem2">
                <div class="ideaImgBox ideaImgBoxLeft">
                  <img class="ideaImg productImg" src="../assets/aboutLanshu/manage.png" alt="" />
                </div>
                <div class="ideaTitleBox">
                  <div class="ideaTitle1">管理理念</div>
                  <div class="ideaTitle3">Management philosophy</div>
                  <div class="ideaTitle2">领导做正确的事 团队正确的做事</div>
                </div>
              </div>
              <div class="ideaBoxLeftItem ideaItem3">
                <div class="ideaImgBox ideaImgBoxLeft">
                  <img class="ideaImg productImg" src="../assets/aboutLanshu/learn.png" alt="" />
                </div>

                <div class="ideaTitleBox">
                  <div class="ideaTitle1">学习理念</div>
                  <div class="ideaTitle3">Learning philosophy</div>
                  <div class="ideaTitle2">吾必每日三省吾身</div>
                </div>
              </div>
            </div>
            <div class="ideaBoxMiddle">
              <img class="treeImg" src="../assets/newLasur/valueBottom2.png" alt="" />
            </div>
            <div class="ideaBoxRight ideaImgBoxRight">
              <div class="ideaBoxRightItem ideaItem4">
                <div class="ideaImgBox ideaImgBoxRight">
                  <img class="ideaImg productImg" src="../assets/aboutLanshu/talent.png" alt="" />
                </div>
                <div class="ideaTitleBox">
                  <div class="ideaTitle1">人才理念</div>
                  <div class="ideaTitle3">Talent concept</div>
                  <div class="ideaTitle2">员工的成长才是企业的财富</div>
                </div>
              </div>
              <div class="ideaBoxRightItem ideaItem5">
                <div class="ideaImgBox ideaImgBoxRight">
                  <img class="ideaImg productImg" src="../assets/aboutLanshu/service.png" alt="" />
                </div>
                <div class="ideaTitleBox">
                  <div class="ideaTitle1">服务理念</div>
                  <div class="ideaTitle3">Service concept</div>
                  <div class="ideaTitle2">消费者说好才是真的好</div>
                </div>
              </div>
              <div class="ideaBoxRightItem ideaItem6">
                <div class="ideaImgBox">
                  <img class="ideaImg productImg" src="../assets/aboutLanshu/market.png" alt="" />
                </div>
                <div class="ideaTitleBox">
                  <div class="ideaTitle1">营销理念</div>
                  <div class="ideaTitle3">Marketing concept</div>
                  <div class="ideaTitle2">把握行业脉搏 引领行业潮流</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section pageBox6">
        <div class="goTop" @click="scrollToTop"></div>
        <div class="pageBoxOut2">
          <div class="headerTitle1" style="margin-top: 40px;">企业核心人物</div>
          <div class="headerLine"></div>
          <div class="headerTitle2">COMPANY TEAM</div>
          <div class="teamBox">
            <div class="teamBoxItem" v-for="(item, index) in teamItem" :key="index">
              <img class="teamItemImg" :src="item.teamimg" alt="" />
              <div class="teamTitleBox">
                <div class="teamTitle1">{{ item.teamtitle1 }}</div>
                <div class="yszi">{{ item.teamtitle3 }}</div>
                <div class="teamTitle2">{{ item.teamtitle2 }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section pageBox7">
        <div class="goTop" @click="scrollToTop"></div>
        <div class="pageBoxOut2">
          <div class="headerTitle1 pageBoxTitle7">企业荣誉</div>
          <div class="headerLine"></div>
          <div class="headerTitle2">ENTERPRISE HONOR</div>
          <div class="carouselBox" style="margin-top: 3.23vh;">
            <el-carousel :interval="4000" arrow="always" height="64.2vh" autoplay indicator-position="none"
              class="carouse">
              <el-carousel-item v-for="(item, index) in honorData" :key="index" class="carouselItem">
                <div class="itemBox">
                  <img :src="item.img" alt="" />
                  <!-- <div class="itemImgBox" v-for="(imgItem,index) in item.img" :key="index">
									<img class="itemImgBoximg" :src="imgItem.honorimg" alt="">
								</div> -->
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>

      <div class="section pageBox8">
        <div class="goTop" @click="scrollToTop"></div>
        <div class="pageBoxOut2">
          <!-- 底部 -->
          <div class="footerBox">
            <div class="footerBoxHeader">
              <div class="footerBoxHeaderLeft">
                <img class="codeImg" src="../assets/code.png" alt="" />
                <span class="codeText">兰树公众号</span>
              </div>
              <div class="footerBoxHeaderCenter">
                <img class="codeImg" src="../assets/xinqingBrand/assets/xcxNew.jpg" alt="" />
                <span class="codeText">兰树云小程序</span>
              </div>
              <div class="footerBoxHeaderRight">
                <img class="codeImg" src="../assets/xinqingBrand/assets/xinqingtang.png" alt="">
                <span class="codeText">官方微信公众号</span>
              </div>
              <!-- <div class="footerBoxHeaderRight">
					  				<img class="codeImg" src="../assets/code.png" alt="">
					  				<span class="codeText">兰树客服(QQ)</span>
					  			</div> -->
            </div>
            <div class="footerMainBox">
              <li class="footerShop">
                <a target="_blank"
                  href="https://huaishu.tmall.com/shop/view_shop.htm?spm=a230r.7195193.1997079397.2.124378dduXIhiW">淮树旗舰店</a>
              </li>
              <li class="footerShop">
                <a target="_blank"
                  href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s">心清堂官方企业店</a>
              </li>
              <li class="footerShop">
                <a target="_blank" href="https://shop349169226.taobao.com/?spm=a21xtw.29978516.0.0">水姻缘旗舰店</a>
              </li>
              <li class="footerShop">
                <a target="_blank"
                  href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s">一清堂官方企业店</a>
              </li>
              <li class="footerShop">
                <a target="_blank" href="https://drchung.tmall.com"><span>Dr.CHUNG</span>旗舰店</a>
              </li>
              <li class="footerShop">
                <a target="_blank" href="https://zhibenqingfang.tmall.com">植本清方旗舰店</a>
              </li>
              <div class="lastHeader">
                <li><router-link to="/login" tag="a">登录</router-link></li>
                |
                <li><router-link to="/login" tag="a">注册</router-link></li>
              </div>
            </div>

            <div class="footerInfoBox">
              <div class="emailBox">邮箱: postermaster@lasur.com</div>
              <div class="phoneBox">电话: 0571-89025888</div>
              <div class="addressBox">
                地址: 浙江省杭州市之江东路越秀·维多利中心A座 17楼
              </div>
            </div>

            <div class="footerLine"></div>
            <div class="footerBoxBottom">
              <div class="footerLeft">
                Copyright © 2023 兰树化妆品股份有限公司
                <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备20018890号-1</a>
                | <img height="16px" src="../assets/plice.png" />&nbsp;<a target="_blank"
                  href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33052102000740">浙公网安备
                  33052102000740号</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </full-page>
  </div>
</template>

<script>
export default {
  data() {
    return {
      options: {
        licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
        //是否显示导航，默认为false
        navigation: true
      },
      culture: ["culture0", "culture1", "culture2", "culture3", "culture4"],
      visioningItem: [
        {
          id: 1,
          img: require("../assets/newLasur/aboutItem1.png"),
          title1: "梦想",
          title2: "传播美·奉献爱·圆梦想"
        },
        {
          id: 2,
          img: require("../assets/newLasur/aboutItem2.png"),
          title1: "使命",
          title2: "传承中医国粹 弘扬中医美容"
        },
        {
          id: 3,
          img: require("../assets/newLasur/aboutItem3.png"),
          title1: "愿景",
          title2: "将美容师培养成美容医师"
        }
      ],
      cultureItem: [
        {
          id: 1,
          img: require("../assets/newLasur/cultureItem1.png"),
          title1: "Ren",
          title: "同情、关心、爱护"
        },
        {
          id: 2,
          img: require("../assets/newLasur/cultureItem2.png"),
          title1: "Yi",
          title: "正直、正当、道义"
        },
        {
          id: 3,
          img: require("../assets/newLasur/cultureItem3.png"),
          title1: "Li",
          title: "礼仪、礼貌、礼节"
        },
        {
          id: 4,
          img: require("../assets/newLasur/cultureItem4.png"),
          title1: "Zhi",
          title: "明是非、辨善恶、知人知己"
        },
        {
          id: 5,
          img: require("../assets/newLasur/cultureItem5.png"),
          title1: "Xin",
          title: "诚实、守信、坚定、信赖"
        }
      ],
      teamItem: [
        {
          id: 1,
          teamimg: require("../assets/newLasur/jingying1.png"),
          teamtitle1: "钟鸣",
          teamtitle2: "兰树股份创始人，董事长",
          teamtitle3: "Zhongming"
        },
        {
          id: 2,
          teamimg: require("../assets/newLasur/jingying2.png"),
          teamtitle1: "戴冰蓝",
          teamtitle2: "兰树股份总经理",
          teamtitle3: "Daibinglan"
        }
        // {
        // 	id:3,
        // 	teamimg:require('../assets/newLasur/jingying3.png'),
        // 	teamtitle1:'陈绍俊',
        // 	teamtitle2:'兰树股份市场部总监',
        // 	teamtitle3:'Chenshaojun',
        // }
      ],
      honorData: [
         {
          id: 3,
          img: require("../assets/aboutLanshu/ry3.jpg")
        },
        {
          id: 1,
          img: require("../assets/aboutLanshu/ry1.jpg")
          // img:[
          // 	{
          // 		id:1,
          // 		honorimg:require('../assets/aboutLanshu/07.jpg'),
          // 	},
          // 	{
          // 		id:2,
          // 		honorimg:require('../assets/aboutLanshu/01.png'),
          // 	},
          // 	{
          // 		id:3,
          // 		honorimg:require('../assets/aboutLanshu/02.png'),
          // 	},
          // 	{
          // 		id:4,
          // 		honorimg:require('../assets/aboutLanshu/03.png'),
          // 	},
          // 	{
          // 		id:5,
          // 		honorimg:require('../assets/aboutLanshu/04.png'),
          // 	},
          // 	{
          // 		id:6,
          // 		honorimg:require('../assets/aboutLanshu/05.png'),
          // 	}
          // ]
        },
        {
          id: 2,
          img: require("../assets/aboutLanshu/ry2.jpg")
          // 			img:[
          // 				{
          // 					id:1,
          // 					honorimg:require('../assets/aboutLanshu/honnerImgNew.jpg'),
          // 				},
          //   {
          //     id:2,
          //     honorimg:require('../assets/aboutLanshu/06.png')
          //   }
          // 			]
        }

      ]
    };
  },
  methods: {
    scrollToTop() {
      fullpage_api.moveTo(1);
    },
    // over:function(){
    // 	var s = document.getElementById("zhi");
    // 	s.src="../assets/aboutLanshu/zhiC.png"
    // },

    // out:function(){
    // 	var s = document.getElementById("zhi");
    // 	s.src="../assets/aboutLanshu/zhi.png"
    // }
    enterAboutUs() {
      this.$router.push({ path: "/lasurDetail" });
    },
    enterHome() {
      this.$router.push({ path: "/" });
    }
  }
};
</script>

<style scoped>
.goTop {
  width: 2.6vw;
  height: 5.38vh;
  background: url(../assets/newLasur/goTop.png) no-repeat;
  background-position: 50% 50%;
  background-size: 100%;
  overflow: hidden;
  position: absolute;
  right: 3.8vw;
  bottom: 9.25vh;
  cursor: pointer;
  z-index: 999;
}

.goTop:hover {
  background: url(../assets/newLasur/goTop2.png) no-repeat;
  background-position: 50% 50%;
  background-size: 100%;
  overflow: hidden;
}

.topBgBox {
  width: 21%;
  float: right;
  display: flex;
  flex-direction: column;
  text-align: left;
  top: 5%;
  right: 0%;
  opacity: 0.5;
  position: relative;
  -moz-transition: 1.5s;
  -webkit-transition: 1.5s;
  animation: topbgbox 1.5s;
  -webkit-animation: topbgbox 1.5s;
}

.pageBox1.active .topBgBox {
  right: 6%;
  opacity: 1;
}

.topTitle {
  min-width: 3.65vw;
  height: 3.55vh;
  font-size: 1.82vw;
  font-family: SourceHanSansCN-Bold;
  font-weight: bold;
  color: #ffffff;
  line-height: 3.55vh;
}

.topLine {
  width: 5.89vw;
  height: 0.43vh;
  background: #80ff00;
  border-radius: 0.22vh;
  margin-top: 1.72vh;
}

.topTime {
  width: 3.65vw;
  height: 1.61vh;
  font-size: 0.78125vw;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  color: #ffffff;
  line-height: 1.61vh;
  margin-top: 1.34vh;
}

.topDetail {
  min-width: 10.9375vw;
  height: 13.55vh;
  font-size: 0.78125vw;
  font-family: SourceHanSansCN-Light;
  font-weight: 300;
  color: #ffffff;
  line-height: 3.98vh;
  margin-top: 3.48vh;
}

.topImg {
  margin-top: 5.91vh;
  width: 15.1vw;
  height: 3.23vh;
}

.topImg img {
  width: 100%;
  height: 100%;
}

.aboutContainer {
  margin: 0;
  padding: 0;
}

.pageBox1 {
  width: 100%;
  /* background: url(https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-06-25_14-19-10_29116.png)
    no-repeat; */
  background-position: 50% 50%;
  background-size: 100%;
  overflow: hidden;
}

.pageBox2 {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}

.pageBoxOut2 {
  width: 100%;
  height: 100%;
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  box-sizing: border-box;
}

.headerTitle1 {
  display: flex;
  font-size: 1.71875vw;
  font-family: SourceHanSansCN-Bold;
  font-weight: Bold;
  color: #0839de;
  /* line-height: 30px; */
  justify-content: center;
}

.pageBoxTitle7 {
  margin-top: 5rem;
}

.headerTitle2 {
  display: flex;
  font-size: 0.78125vw;
  font-family: SourceHanSansCN-Normal;
  font-weight: normal;
  color: #111111;
  /* line-height: 20px; */
  justify-content: center;
  margin-top: 0.5vh;
}

.headerLine {
  display: flex;
  width: 5.89vw;
  height: 0.43vh;
  background: #80ff00;
  margin: 0 auto;
  border-radius: 1px;
  margin-top: 0.3vh;
}

.middleBox {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  align-items: center;
  justify-content: space-around;
  box-sizing: border-box;
  margin-top: 3.33vh;
}

.middleBoxLeft {
  width: 76%;
  font-size: 0.833vw;
  font-family: SourceHanSansCN-Light;
  font-weight: light;
  color: #000000;
  position: relative;
  left: -20em;
  opacity: 0;
  /* line-height: 26px; */
  /* line-height: 23px; */
  /* letter-spacing: 0.05rem; */
  box-sizing: border-box;
  -moz-transition: 1.5s;
  -webkit-transition: 1.5s;
  /* text-indent: 2em; */
  margin-top: 3.39vh;
  /* animation: middleText 3s;
		-webkit-animation: middleText 3s; */
}

.middleBoxLeftNew {
  margin-top: 0.5rem !important;
}

.pageBox2.active .middleBoxLeft {
  opacity: 1;
  left: 0;
}

/* 动画效果 */
@keyframes middleText {
  from {
    opacity: 0;
    left: -20em;
  }

  to {
    opacity: 1;
    left: 0;
  }
}

@-webkit-keyframes rightImg

/* Safari 和 Chrome */
  {
  from {
    opacity: 0;
    left: -20em;
  }

  to {
    opacity: 1;
    left: 0;
  }
}

.middleBoxRight {
  width: 29%;
  z-index: 999;
  animation: rightImg 3s;
  -webkit-animation: rightImg 3s;
  /* Safari 和 Chrome */
}

/* 动画效果 */
@keyframes rightImg {
  from {
    opacity: 0;
    width: 0%;
  }

  to {
    opacity: 1;
    width: 65%;
  }
}

@-webkit-keyframes rightImg

/* Safari 和 Chrome */
  {
  from {
    opacity: 0;
    width: 0%;
  }

  to {
    opacity: 1;
    width: 65%;
  }
}

.bottomImg {
  width: 0%;
  opacity: 0;
  box-sizing: border-box;
  position: relative;
  -moz-transition: 2s;
  -webkit-transition: 2s;
  /* animation: rightImg 3s;
		-webkit-animation: rightImg 3s;	 */
}

.headerTitleCul {
  line-height: 30px !important;
}

.pageBox2.active .bottomImg {
  width: 65%;
  opacity: 1;
}

.centerBottom {
  width: 76%;
  /* display: flex; */
  margin: 0 auto;
  box-sizing: border-box;
}

.pageBox3 {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f3f3f3;
  overflow: hidden;
}

.mainBox {
  width: 75%;
  display: flex;
  flex-direction: row;
  margin: 0 auto;
  justify-content: space-around;
  margin-top: 2rem;
}

.mainBoxItem {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.mainBoxTitleBox {
  width: 100%;
  margin: 0 auto;
  text-align: center;
  position: relative;
  top: 50%;
  opacity: 0;
  -moz-transition: 1s;
  -webkit-transition: 1s;
  /* animation: mainTitle 3s;
		-webkit-animation: mainTitle 3s; */
}

.pageBox3.active .mainBoxTitleBox {
  top: 0;
  opacity: 1;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  position: relative;
}

/* 动画效果 */
@keyframes mainTitle {
  from {
    opacity: 0;
    top: 30%;
  }

  to {
    opacity: 1;
    top: 0;
  }
}

@-webkit-keyframes mainTitle {
  from {
    opacity: 0;
    top: 30%;
  }

  to {
    opacity: 1;
    top: 0;
  }
}

.mainBoxTitle1 {
  font-size: 2.25rem;
  font-family: MicrosoftYaHei;
  color: #000000;
  line-height: 24px;
  margin-top: 1.5em;
}

.mainBoxTitle2 {
  font-size: 1rem;
  font-family: MicrosoftYaHei;
  color: #666666;
  line-height: 24px;
  margin-top: 1em;
}

.mainBoxItemImg {
  width: 0%;
  opacity: 0;
  position: relative;
  transform: rotate(0deg);
  -moz-transition: 2s;
  -webkit-transition: 2s;
  /* animation: xuanzhuan 3s;
		-webkit-animation: xuanzhuan 3s; */
}

.valueBottom {
  margin-top: 8.6vh;
  width: 5vw;
  /* height: 2.69vh; */
}

.valueBottom img {
  width: 100%;
  height: 100%;
}

.pageBox3.active .mainBoxItemImg {
  width: 70%;
  opacity: 1;
  position: relative;
}

/* 动画效果 */
@keyframes xuanzhuan {
  from {
    opacity: 0;
    transform: rotate(270deg);
  }

  to {
    opacity: 1;
    transform: rotate(0deg);
  }
}

@-webkit-keyframes xuanzhuan {
  from {
    opacity: 0;
    transform: rotate(270deg);
  }

  to {
    opacity: 1;
    transform: rotate(0deg);
  }
}

.pageBox4 {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff;
  overflow: hidden;
}

.cultureBox {
  position: relative;
  width: 100%;
  height: 51.5vh;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  margin: 0 auto;
  margin-top: 73px;
  box-sizing: border-box;
  background: blue;
}

.bg {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
}

.pageBox4.active .culture0 {
  animation: bounceInLeft 1s cubic-bezier(0.215, 0.61, 0.355, 1) 6s 1 alternate forwards;
  -webkit-animation: bounceInLeft 0.75s cubic-bezier(0.215, 0.61, 0.355, 1) 2s 1 alternate forwards;
  /*Safari and Chrome*/
  /* transform: translateX(0); */
}

.pageBox4.active .culture1 {
  animation: bounceInLeft 1s cubic-bezier(0.215, 0.61, 0.355, 1) 4.5s 1 alternate forwards;
  -webkit-animation: bounceInLeft 0.75s cubic-bezier(0.215, 0.61, 0.355, 1) 1.5s 1 alternate forwards;
  /*Safari and Chrome*/
}

.pageBox4.active .culture2 {
  animation: bounceInLeft 1s cubic-bezier(0.215, 0.61, 0.355, 1) 3s 1 alternate forwards;
  -webkit-animation: bounceInLeft 1s cubic-bezier(0.215, 0.61, 0.355, 1) 1s 1 alternate forwards;
  /*Safari and Chrome*/
}

.pageBox4.active .culture3 {
  animation: bounceInLeft 1s cubic-bezier(0.215, 0.61, 0.355, 1) 1.5s 1 alternate forwards;
  -webkit-animation: bounceInLeft 1s cubic-bezier(0.215, 0.61, 0.355, 1) 0.5s 1 alternate forwards;
  /*Safari and Chrome*/
}

.pageBox4.active .culture4 {
  animation: bounceInLeft 1.5s cubic-bezier(0.215, 0.61, 0.355, 1) 0s 1 alternate forwards;
  -webkit-animation: bounceInLeft 1.5s cubic-bezier(0.215, 0.61, 0.355, 1) 0s 1 alternate forwards;
  /*Safari and Chrome*/
}

@keyframes bounceInLeft {
  0% {
    opacity: 0;
    transform: translate3d(-3000px, 0, 0);
  }

  100% {
    transform: none;
  }
}

.culture0,
.culture1,
.culture2,
.culture3,
.culture4 {
  transform: translate3d(-3000px, 0, 0);
}

.cultureItem {
  text-align: center;
  /* transform: translateX(-100%); */
}

.cultureItemImg {
  width: 17.86vw;
  /* height: 36.88vh; */
}

.cultureTitle {
  min-width: 119px;
  height: 15px;
  font-size: 1.2vw;
  font-family: SourceHanSansCN-Light;
  font-weight: 400;
  color: #ffffff;
  margin-top: 2.15vh;
}

.cultureTitle1 {
  min-width: 119px;
  height: 15px;
  font-size: 1.927vw;
  font-family: AntroVectra;
  font-weight: 400;
  color: #80ff00;
  text-align: center;
  position: absolute;
  bottom: 10vh;
  left: 5.8vw;
  /* z-index: 999; */
}

.pageBox5 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #f6f7f8;
  overflow: hidden;
}

.ideaBox {
  width: 100%;
  height: 70%;
  margin: 0 auto;
  display: flex;
  margin-top: 3rem;
  box-sizing: border-box;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  background: url(https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-08-18_14-00-38_17772.png) no-repeat;
  background-position: 50% 50%;
  background-size: 100%;
  overflow: hidden;
  position: relative;
  /* position: absolute;
		bottom: 0; */
}

.ideaBoxLeft {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ideaTitleBox {
  width: 90%;
  display: flex;
  flex-direction: column;
  margin-left: 2em;
}

.ideaTitle1 {
  font-size: 1.98vw;
  font-family: SourceHanSansCN-Bold;
  font-weight: 500;
  color: #fff;
  line-height: 22px;
}

.ideaTitle2 {
  font-size: 1.2vw;
  font-family: SourceHanSansCN-Light;
  font-weight: 400;
  color: #fff;
  /* line-height: 20px; */
  margin-top: 17px;
}

.ideaTitle3 {
  font-size: 1.09vw;
  font-family: AntroVectra;
  font-weight: 400;
  color: #80ff00;
  line-height: 21px;
  margin-top: 10px;
}

.yszi {
  font-size: 0.99vw;
  font-family: AntroVectra;
  font-weight: 400;
  color: #80ff00;
}

.ideaBoxLeftItem {
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-top: 5.8vh;
  position: relative;
  left: -15rem;
  opacity: 0;
  transition: 3s ease;
  -moz-transition: 2s;
  -webkit-transition: 2s;
  /* animation: leftItem 10s;
		-webkit-animation: leftItem 10s; */
}

.pageBox5.active .ideaBoxLeftItem {
  opacity: 1;
  left: 5rem;
  position: relative;
}

/* 动画效果 */
@keyframes leftItem {
  from {
    opacity: 0;
    left: -15em;
  }

  to {
    opacity: 1;
    left: 0;
  }
}

@-webkit-keyframes leftItem {
  from {
    opacity: 0;
    left: -15em;
  }

  to {
    opacity: 1;
    left: 0;
  }
}

.ideaBoxRightItem {
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-top: 5.8vh;
  position: relative;
  left: 15rem;
  opacity: 0;
  -moz-transition: 2s;
  -webkit-transition: 2s;
  /* animation: rightItem 10s;
		-webkit-animation: rightItem 10s; */
}

.pageBox5.active .ideaBoxRightItem {
  opacity: 1;
  left: -5rem;
  position: relative;
}

/* 动画效果 */
@keyframes rightItem {
  from {
    opacity: 0;
    left: 15em;
  }

  to {
    opacity: 1;
    left: 0;
  }
}

@-webkit-keyframes rightItem

/* Safari 和 Chrome */
  {
  from {
    opacity: 0;
    left: 15em;
  }

  to {
    opacity: 1;
    left: 0;
  }
}

/*
	.ideaItem2 .ideaImgBox{
		margin-left:12%;
	} */

/* .ideaItem5 .ideaImgBox{
		margin-left:2rem;
	} */

/* .ideaItem4 .ideaImgBox{
		margin-left:1%;
	}
	 */

.treeImg {
  width: 100%;
}

/* tree动画效果 */
@keyframes tree {
  from {
    opacity: 0;
    width: 100%;
  }

  to {
    opacity: 1;
    width: 100%;
  }
}

@-webkit-keyframes tree {
  from {
    opacity: 0;
    width: 100%;
  }

  to {
    opacity: 1;
    width: 100%;
  }
}

.ideaImg {
  margin-top: -1.8vh;
  width: 70px;
}

.ideaBoxMiddle {
  width: 7.45vw;
  position: absolute;
  bottom: 20px;
  /* display: flex;
		flex-direction: column;
		align-items: center; */
  /* margin-top: 2rem; */
  /* margin-left: -3em; */
  /* animation: tree 10s;
		-webkit-animation: tree 10s; */
}

.ideaBoxRight {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.pageBox6 {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}

.teamBox {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin: 0 auto;
  padding: 0 400px;
  margin-top: 2%;
  box-sizing: border-box;
  background: url(https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-08-18_14-02-13_80499.png) no-repeat;
  background-position: 50% 50%;
  background-size: 100%;
  overflow: hidden;
}


.teamBoxItem {
  margin-top: 8vh;
  width: 15vw;
  height: 64.4vh;
  border-radius: 20px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: 1s;
  cursor: pointer;
  overflow: hidden;
  opacity: 0;
  -moz-transition: 1s;
  -webkit-transition: 1.5s;
  /* transform:rotate(0deg); */
  /* box-shadow: 0 5px 15px -5px rgba(0,0,0,.5); */
  /* animation: team 5s;
		-webkit-animation: team 5s; */
}

.pageBox6.active .teamBoxItem {
  opacity: 1;
  width: 18.9vw;
}

/* 精英团队动画效果 */
@keyframes team {
  from {
    opacity: 0;
    transform: rotate(120deg);
  }

  to {
    opacity: 1;
    transform: rotate(0deg);
  }
}

@-webkit-keyframes team {
  from {
    opacity: 0;
    transform: rotate(120deg);
  }

  to {
    opacity: 1;
    transform: rotate(0deg);
  }
}

.teamBoxItem:hover .teamItemImg {
  transform: scale(1.05);
  transition: 1.5s ease;
}

.teamBoxItem:hover .teamTitleBox {
  background: #0839de;
  transition: 1.5s ease;
}

.teamBoxItem:hover .teamTitle1 {
  color: #ffffff;
  transition: 1s ease;
}

.teamBoxItem:hover .teamTitle2 {
  color: #ffffff;
  transition: 1s ease;
}

.teamTitleBox {
  width: 100%;
  display: flex;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  flex-direction: column;
  align-items: center;
  background: #ebebeb;
  /* background: #003F98; */
  transition: 1s ease;
  overflow: hidden;
  /* margin-top: -4rem; */
  z-index: 999;
  padding-top: 1vh;
}

.teamItemImg {
  width: 100%;
  transition: 1s ease;
}

.teamTitle1 {
  font-size: 1.82vw;
  font-family: SourceHanSansCN-Bold;
  font-weight: bold;
  color: #222;
  /* color: #fff; */
  line-height: 1.07vh;
  margin-top: 3vh;
  transition: 1s ease;
  z-index: 999;
}

.teamTitle2 {
  font-size: 1.09vw;
  font-family: SourceHanSansCN-Light;
  font-weight: lighter;
  color: #222;
  /* color: #fff; */
  line-height: 21px;
  /* margin-top: 1em; */
  padding-bottom: 1em;
  transition: 1s ease;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* pageBox7 */
.pageBox7 {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  background-color: #fff;
}

.carouselBox {
  width: 80%;
  height: 100%;
}

.carouselItem {
  width: 100%;
  /* display: flex;
		justify-content: center; */
}

.itemBox {
  width: 71.9vw;
  margin: 0 auto;
  display: flex;
  align-content: center;
  flex-direction: row;
  flex-wrap: wrap;
}

.itemBox img {
  width: 100%;
  height: 100%;
}

/* footer */
.pageBox8 {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  background-color: #f8f9fb;
}

.footerBox {
  width: 90%;
  /* height: 287px; */
  background: #f8f9fb;
  /* position:absolute;
	 	bottom:0; */
  margin: 0 auto;
  flex-direction: column;
  z-index: 999;
}

.footerBoxHeader {
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 2%;
}

.footerBoxHeaderLeft {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footerBoxHeaderCenter {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 5em;
}


.footerBoxHeaderRight {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 5em;
}

.codeImg {
  width: 90px;
}

.codeText {
  font-size: 0.88em;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
  /* margin-top: 0em; */
}

.footerLine {
  width: 79%;
  height: 1px;
  display: flex;
  background: #000000;
  opacity: 0.1;
  margin: 0 auto;
  align-items: center;
  margin-top: 1em;
}

.footerInfoBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2rem;
}

.emailBox {
  font-size: 0.875rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 20px;
}

.phoneBox {
  font-size: 0.875rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 20px;
  margin-top: 0.5rem;
}

.addressBox {
  font-size: 0.875rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 20px;
  margin-top: 0.5rem;
}

.footerBoxBottom {
  display: flex;
  margin: 0 auto;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  margin-top: 1rem;
}

.footerLeft {
  font-size: 0.875em;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
}

.footerLeft a {
  text-decoration: none;
  cursor: pointer;
  color: #666666;
}

.footerLeft a:hover {
  color: #003f98;
}

.footerMiddle {
  display: flex;
  flex-direction: column;
  margin-left: 1em;
}

.footerMiddle span {
  font-size: 0.875em;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
}

.footerRight {
  display: flex;
  flex-direction: column;
  margin-left: 1em;
}

.footerRight li a {
  text-decoration: none;
  font-size: 0.875em;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 28px;
}

.footerRight li {
  list-style: none;
}

.footerLast {
  display: flex;
  flex-direction: column;
  margin-left: 1em;
}

.lastHeader {
  display: flex;
  flex-direction: row;
  font-size: 0.875em;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 28px;
  margin-left: 2em;
}

.lastHeader li a {
  text-decoration: none;
  font-size: 0.875rm;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 28px;
}

.lastHeader li {
  list-style: none;
}

.footerLast span {
  font-size: 0.875em;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
}

.footerMainBox {
  display: flex;
  flex-direction: row;
  margin: 0 auto;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  margin-top: 2em;
}

.footerShop {
  list-style: none;
  position: relative;
}

.footerShop a {
  text-decoration: none;
  font-size: 0.875rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
  padding-left: 2em;
  line-height: 28px;
}

.footerShop span {
  margin-right: 10px;
}

.footerShop span::after {
  content: "+";
  display: block;
  position: absolute;
  top: -6px;
  right: 43px;
}

/* 导航 */
.navBar {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: absolute;
  justify-content: space-between;
  top: 0;
  /* border-bottom:1px solid rgba(255,255,255,0.2); */
  z-index: 9999;
}

.router-link-active {
  border-bottom: 3px solid #000;
}

.navLogo {
  width: 10%;
  margin-left: 5em;
  cursor: pointer;
}

.navBarItem {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  /* margin-right: 5em; */
}

.navBarItem li {
  list-style: none;
  /*padding: 1.56em 2.5em 1.56em 2.5em;*/
  float: left;
  /* margin-left: 2em; */
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.navBarItem li a {
  text-decoration: none;
  font-size: 0.875rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #000;
  line-height: 20px;
  padding-top: 1.3em;
  padding-bottom: 1.3em;
  padding-left: 0.8rem;
  padding-right: 0.8rem;
}

/* .elDropdown{
		margin-left: -5em;
		margin-top: -1em;
	} */

.elDropdown a {
  color: #111111;
  text-decoration: none;
}

.el-dropdown {
  vertical-align: top;
}

.el-dropdown+.el-dropdown {
  margin-left: 15px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.el-dropdown-link {
  cursor: pointer;
}

.el-icon-arrow-down {
  font-size: 12px;
}





.pageBoxMiddle {
  width: 90%;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.mainContent {
  /* width:66%; */
  width: 75.73vw;
  height: 39.25vh;
  display: flex;
  flex-direction: row;
  background: #0839de;
  margin-top: 1%;
  border-radius: 7px;
  position: relative;
}

.contentLine {
  width: 0.26vw;
  height: 20vh;
  /* position: relative; */
  background: #80ff00;
  border-radius: 6px;
  position: absolute;
  left: 0;
  top: -13.44vh;
  -moz-transition: 1s;
  -webkit-transition: 1s;
  /* animation: aboutus3 3s;
	-webkit-animation: aboutus3 3s; */
}

.pageBox1.active .contentLine {
  left: 2.92vw;
  /* position: relative; */
}

.mainContentLeftBox {
  /* width: 75.73vw;
	  height:260px; */
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  margin-left: 8%;
  margin-top: 5%;
  padding-bottom: 5%;
  box-sizing: border-box;
}

.mainContentLeft {
  /* width: 60%; */
  width: 47.6vw;
  height: 14.08vh;
  float: left;
  font-size: 0.99vw;
  /* font-family: PingFangSC-Regular, PingFang SC; */
  /* font-family: SourceHanSansCN-ExtraLight; */
  font-weight: 400;
  color: #fff;
  line-height: 3.52vh;
  box-sizing: border-box;
  letter-spacing: 0.03rem;
  text-indent: 0em;
  word-break: break-all;
}


.mainContentRight {
  width: 0%;
  /* width:352px; */
  /* height: 240.5px; */
  position: absolute;
  right: 0%;
  top: 13%;
  -moz-transition: 1.5s;
  -webkit-transition: 1.5s;
  /* animation: aboutus 3s;
	-webkit-animation: aboutus 3s; */
}

.pageBox1.active .mainContent .mainContentRight {
  /* width:352px; */
  /* height: 240.5px; */
  /* opacity: 1; */
  width: 18.28125vw;
  position: absolute;
  right: -4.48vw;
  top: -17vh;
  /* object-fit: cover; */
  /* transition: 0.2s; */
}

.leftBottom:hover {
  transform: scale(1.1);
}

.leftBottom {
  width: 0%;
  position: absolute;
  right: 0%;
  top: 16.13vh;
  -moz-transition: 1.5s;
  -webkit-transition: 1.5s;
}

.pageBox1.active .mainContent .leftBottom {
  /* width:352px; */
  /* height: 240.5px; */
  /* opacity: 1; */
  /* width: 313px;
	  height: 254px; */
  width: 24.48vw;
  /* height: 22%; */
  position: absolute;
  right: -2.24vw;
  top: 16.13vh;
}

.leftBottom img {
  width: 100%;
  height: 100%;
  /* object-fit: none; */
}

.seeMore {
  width: 12.08vw;
  height: 4.95vh;
  /* animation: aboutus2 2s;
	-webkit-animation: aboutus2 2s;	 */
  position: relative;
  top: 4.62vh;
  box-sizing: border-box;
  cursor: pointer;
  -moz-transition: 1.5s;
  -webkit-transition: 1.5s;
  background: #fff;
  border-radius: 2.4vh;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.seeMore img {
  width: 1.77vw;
  height: 3.66vh;
  /* margin-left: 5px; */
  /* background: #000; */
}

.seeMore span {
  /* width: 7.91vw; */
  height: 4.95vh;
  font-size: 0.89vw;
  font-family: SourceHanSansCN-Bold;
  font-weight: bold;
  color: #0839de;
  line-height: 4.95vh;
  text-align: left;
  text-indent: 1em;
  /* background: #000; */
}

.pageBox1.active .mainContent .seeMore {
  position: relative;
  top: 3rem;
  /* width: 20%; */
  box-sizing: border-box;
  cursor: pointer;
}

.aboutUsBox {
  width: 11vw;
  position: absolute;
  top: -13.44vh;
  left: 4.48vw;
  display: flex;
  flex-direction: column;
  /* background: #000; */
  /* margin-top: 2em; */
}

.aboutUsBox span {
  font-size: 2.55vw;
  font-family: SourceHanSansCN-Bold;
  font-weight: bold;
  color: #0839de;
  /* line-height: 64px;
		margin-left: 7%; */
}

.introduce {
  font-size: 1.2vw;
  font-family: SourceHanSansCN-Normal;
  font-weight: normal;
  color: #000;
  /* line-height: 30px;
		margin-left: 7%; */
}
</style>



// WEBPACK FOOTER //
// src/components/AboutLanShu.vue